import { connect } from 'react-redux';
import { ApplicationState } from '../../../../store';
import PreCasInterviewPage2, { IProps } from './index';

const mapStateToProps = (state: ApplicationState): IProps => {
  const defaultValues = {
    campus: '',
    considerOtherUni: true,
    otherUni1: '',
    otherUni2: '',
    selectedResearchMethods: [],
    selectedResearchMethodsOther: '',
    whyNotOtherUni: '',
    considerOtherCourses: undefined,
    considerOtherCourse: '',
    whyNotConsiderOtherCourse: '',
    courseAlignFutureCareer: undefined,
    courseAlignFutureCareerOther: '',
  };

  const {
    campus,
    considerOtherUni,
    otherUni1,
    otherUni2,
    selectedResearchMethods,
    selectedResearchMethodsOther,
    whyNotOtherUni,
    considerOtherCourses,
    considerOtherCourse,
    whyNotConsiderOtherCourse,
    courseAlignFutureCareer,
    courseAlignFutureCareerOther,
  } = { ...defaultValues, ...state.student.preCasInterview };

  const complete =
    campus !== '' &&
    considerOtherUni !== undefined &&
    (considerOtherUni === true
      ? otherUni1 !== '' &&
        otherUni2 !== '' &&
        selectedResearchMethods.length > 0 &&
        (selectedResearchMethods.findIndex(method => method === 'Other') > -1
          ? selectedResearchMethodsOther !== ''
          : true)
      : whyNotOtherUni !== '') &&
    considerOtherCourses !== undefined &&
    (considerOtherCourses === true ? considerOtherCourse !== '' : whyNotConsiderOtherCourse !== '') &&
    courseAlignFutureCareer !== undefined &&
    (courseAlignFutureCareer === false ? courseAlignFutureCareerOther !== '' : true);

  return {
    complete,
    currentStep: 2,
    steps: 4,
    campus,
    considerOtherUni,
    otherUni1,
    otherUni2,
    selectedResearchMethods,
    selectedResearchMethodsOther,
    whyNotOtherUni,
    considerOtherCourses,
    considerOtherCourse,
    whyNotConsiderOtherCourse,
    courseAlignFutureCareer,
    courseAlignFutureCareerOther,
    pageConfig: state.student.config.Interview.Page2,
  };
};

export default connect(mapStateToProps)(PreCasInterviewPage2);
